import { Component } from "react"

class Email extends Component{
    constructor(props){
        super(props)
        this.name = "メールアドレス"
    }
    validate(callbackDialog,requireCheck){
        if(requireCheck && String(this.props).trim().length === 0){
            callbackDialog("エラー",this.name + "は必須です。")
            return false
        }
        if(String(this.props).trim().length > 0){
            if(this.props.length > 100){
                callbackDialog("エラー",this.name + "は100文字以内にしてください。")
                return false
            }
            if(!/^[a-zA-Z0-9_.+-]+@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/.test(this.props)){
                callbackDialog("エラー","メールアドレスの形式で入力してください。")
                return false
            }
        }
        return true
    }
}

export default Email;